import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { VirtualAccountForm } from '../Forms';
import { Text1 } from '../../../styles';


const VirtualAccountModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {props.title ? props.title : `${props.virtualAccount.is_edit ? "Update" : "Create"} Virtual Account`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={725}
            title={false}
            visible={props.visible}
            onCancel={props.toggleVirtualAccountModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <VirtualAccountForm
                onSubmit={props.onSubmit}
                loading={props.loading}
                virtualAccount={props.virtualAccount}
            />
        </EaseModal>
    )
};

export { VirtualAccountModal };